import * as React from 'react';
import { useCallback} from 'react';
import {useDropzone} from 'react-dropzone';


export const ImageUploadFrame = props => {
  const {
    className,
    style,
    onImageAccepted,
    onImageRejected,
    maxSize,
    isDisabled
  } = props;


  const onDrop = useCallback(acceptedFiles => {
    onImageAccepted(acceptedFiles);
  }, []);

  const {getRootProps, getInputProps} = useDropzone({
    onDrop,
    accept: 'image/jpeg, image/png, image/jpg',
    multiple: false,
    disabled: typeof(isDisabled) === 'undefined'
      ? false
      : isDisabled,
    maxSize: maxSize || 500000000,
    onDropRejected: onImageRejected
  });
  return (
    <div style={{
      ...style
    }} className={className} {...getRootProps()}>
      <input {...getInputProps()}/> {props.children}
    </div>
  );
};

export default ImageUploadFrame;